import { useEffect, useState } from 'react'
import { styled } from 'styled-components'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ProfileRootType } from '../../@types/auth'
import { getProfile } from '../../api/auth'
import { getUsableCoupon } from '../../api/coupons'
import { getAllEventSearch } from '../../api/home'
import { getMyshoppingBanner, postLogout, postSupportCoin } from '../../api/login'
import { getOrderList } from '../../api/orderHistory'
import { getGuestRecentProducts, getLikeProducts, getMyReview, getRecentProducts } from '../../api/product'
import { getAccumulations } from '../../api/profile'
import ChannelTalkButton from '../../components/myshopping/ChannelTalkButton'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import PointExchange from '../../components/myshopping/PointExchange'
import PointExchangeCenterModal from '../../components/myshopping/PointExchangeCenterModal'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { IconArrowRight } from '../../components/svg/IconSvg'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage, sendConsoleMessage } from '../../js/postMessage'
import {
  delPrevScroll,
  getParsedLocalStorageItem,
  getParsedSessionStorageItem,
  handleAccessToken,
  plusComma,
} from '../../js/script'
import { useAppContext } from '../../components/provider/AppProvider'

// 이미지 경로
const imgURL = '/images'

export default function MyShopping() {
  const navigate = useNavigate()

  const { isAppView } = useAppContext()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [myItemCount, setMyItemCount] = useState<number>(0)
  const [recentCount, setRecentCount] = useState<number>(0)
  const [wishCount, setWishCount] = useState<number>(0)
  const [orderCount, setOrderCount] = useState<number>(0)
  const [userData, setUserData] = useState<ProfileRootType>()
  const [profileImage, setProfileImage] = useState<string>()
  const [pointModal, setPointModal] = useState<boolean>(false)
  const [coin, setCoin] = useState<number>(0)
  const [accumulation, setAccumulation] = useState<any>()

  const [checkChangePoint, setCheckChangePoint] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [bannerItem, setBannerItem] = useState<any>([])
  const [reviewCount, setReviewCount] = useState<number>(0)
  const { setIsLogin, hasAccessToken } = useCommonContext()

  useEffect(() => {
    if (hasAccessToken) {
      getUsableCoupon()
        .then((res) => {
          setMyItemCount(res.data.totalCount)
        })
        .catch((err) => console.log(err))
    }
  }, [hasAccessToken])

  useEffect(() => {
    if (!isMobile) return // 모바일이 아닐 경우 조기 종료

    const fetchRecentProducts = async () => {
      try {
        if (hasAccessToken) {
          const res = await getRecentProducts(1)
          const filteredProducts = res.data.filter((el: any) => !el.displayCategoryNos.includes('787334'))
          setRecentCount(filteredProducts.length)
        } else {
          const product = window.sessionStorage.getItem('mallProductNo')
          if (product) {
            const productParse = JSON.parse(product)
            if (productParse.length > 0) {
              const res = await getGuestRecentProducts(productParse)
              setRecentCount(res.data.length)
            }
          }
        }
      } catch (err) {
        console.log(err)
      }
    }

    fetchRecentProducts()
  }, [isMobile, hasAccessToken])

  useEffect(() => {
    const fetchData = async () => {
      if (hasAccessToken) {
        try {
          setIsLoading(true)
          const [accumulationRes, coinRes] = await Promise.all([getAccumulations('ADD'), postSupportCoin('total')])
          setAccumulation(accumulationRes.data)
          setCoin(coinRes.data.totalCoin)
        } catch (err) {
          console.log(err)
        } finally {
          setIsLoading(false)
        }
      }
    }

    fetchData()
  }, [checkChangePoint, hasAccessToken])

  useEffect(() => {
    if (hasAccessToken) {
      getProfile()
        .then((res) => {
          const imageUrl = JSON.parse(res.data.additionalInfo)
          setProfileImage(imageUrl?.profileImage)
          setUserData(res.data)
        })
        .catch((err) => console.log(err))
    }
  }, [hasAccessToken])

  useEffect(() => {
    if (hasAccessToken && isMobile) {
      getMyReview()
        .then((res) => {
          setReviewCount(res.data.totalCount)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [hasAccessToken])

  useEffect(() => {
    const fetchLikeProducts = async () => {
      if (!hasAccessToken || !isMobile) return // 인증된 사용자이거나 모바일이 아닐 경우 조기 종료

      try {
        const res = await getLikeProducts(1)
        const filteredProducts = res.data.items.filter((el: any) => !el.displayCategoryNos.includes('787334'))
        setWishCount(filteredProducts.length)
      } catch (err: any) {
        if (err.status === 401) {
          const refresh = getParsedLocalStorageItem('aboutRefreshToken')
          const os = getParsedSessionStorageItem('os')
          handleAccessToken(refresh, os)
        } else {
          console.log(err) // 다른 에러도 로그 출력
        }
      }
    }

    fetchLikeProducts()
  }, [hasAccessToken, isMobile]) // accessToken과 isMobile을 의존성 배열에 추가

  useEffect(() => {
    getAllEventSearch('ING', 1).then((res) => {
      setTotalCount(res.data.totalCount)
      // const sort = res.data.sort((a: any, b: any) => {
      //   return b.eventNo - a.eventNo;
      // });
      // setEventArray(sort);
    })
  }, [])

  useEffect(() => {
    if (hasAccessToken) {
      if (isMobile) {
        getOrderList()
          .then((res) => {
            setOrderCount(res.data.items.length)
          })
          .catch((err) => console.log(err))
      }
    }
  }, [hasAccessToken])

  useEffect(() => {
    getMyshoppingBanner().then((res) => {
      setBannerItem(res.data)
    })
  }, [hasAccessToken])

  useEffect(() => {
    if (!userData) {
      const currentDomain = window.location.hostname
      const channelSessionCookieNumber = document.cookie.match(/ch-session-(\d+)=/)
      if (channelSessionCookieNumber?.length && channelSessionCookieNumber[1]) {
        removeCookie(`ch-session-${channelSessionCookieNumber[1]}`, {
          domain: currentDomain === 'localhost' ? currentDomain : '.aboutfishing.kr',
          path: '/myshopping',
        })
      }
    }
  }, [userData])

  function removeCookie(name: any, options = {}) {
    const { domain, path }: any = options

    document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${path ? `path=${path};` : ''} ${
      domain ? `domain=${domain};` : ''
    }`
  }

  useEffect(() => {
    sendConsoleMessage(`유저 로그인 여부 >>>>>>>> ${hasAccessToken}`)
  }, [])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap sidemenu_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <div className='myshopping_contents'>
              <PageTitle>마이쇼핑</PageTitle>
              {/* 회원일 경우 */}
              {hasAccessToken ? (
                <>
                  <div className='myshopping_header'>
                    <div className='common_head'>
                      <div className='profile_coin_wrap'>
                        <div className='memeber_profile'>
                          <div className='inner_flex'>
                            <div className='profile_img'>
                              <div
                                style={{
                                  backgroundImage: profileImage
                                    ? `url(${profileImage})`
                                    : `url(${imgURL}/noprofile_img.png)`,
                                  backgroundSize: 'cover',
                                  boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset',
                                  backgroundPosition: 'center',
                                  borderRadius: '50%',
                                }}
                              />
                            </div>
                            <div className='user_info'>
                              <div className='user_tit'>
                                <strong className='nickname'>{userData?.nickname}</strong>
                                <span
                                  className='nation'
                                  style={{
                                    backgroundImage: `url(/images/icon_nation.png)`,
                                  }}
                                ></span>
                              </div>
                              {/* {isMobile && (
                            <div className='purchase_benefit'>
                              <Link to='/benefit'>구매 금액별 혜택 보기</Link>
                            </div>
                          )} */}
                              {!isMobile && hasAccessToken ? (
                                isAppView ? null : (
                                  <div className='logout'>
                                    <a
                                      href='#'
                                      onClick={(e) => {
                                        e.preventDefault()
                                        const confirmed = window.confirm('로그아웃을 하시겠습니까?')
                                        if (confirmed) {
                                          ;<Link to='/recordGuide'></Link>
                                          postLogout(Number(userData?.memberId || ''))
                                            .then(() => {
                                              window.localStorage.clear()
                                              delPrevScroll()
                                              navigate('/')
                                              window.location.reload()
                                            })
                                            .catch((err) => {
                                              console.log(err)
                                            })
                                        }
                                      }}
                                    >
                                      로그아웃
                                      <IconArrowRight color='var(--colGray6' />
                                    </a>
                                  </div>
                                )
                              ) : null}
                            </div>
                          </div>
                          {
                            <a
                              className='user_edit'
                              onClick={() => {
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=editMyProfile&ownerUserId=${userData?.memberId}`,
                                  })
                                } else {
                                  navigate('/profile')
                                }
                              }}
                            >
                              프로필 편집
                            </a>
                          }
                        </div>

                        <div className='save_point_con'>
                          <div className='save_point_box'>
                            <div className='coin_item'>
                              {isLoading ? (
                                <SpinnerContainer>
                                  <LoadingSpinner />
                                </SpinnerContainer>
                              ) : (
                                <strong>{plusComma(coin)}</strong>
                              )}
                              <span
                                onClick={() => {
                                  if (isAppView) {
                                    RNPostMessage(AFWebLinkType.moveToLink, {
                                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/coindetail`,
                                    })
                                  } else {
                                    navigate(`/coindetail`)
                                  }
                                }}
                              >
                                피싱코인 내역
                              </span>
                            </div>
                            <span
                              className='exchange_btn'
                              onClick={() => {
                                setPointModal(true)
                              }}
                            >
                              전환
                            </span>
                            <div className='point_item'>
                              {isLoading ? (
                                <SpinnerContainer>
                                  <LoadingSpinner />
                                </SpinnerContainer>
                              ) : (
                                <strong>{plusComma(accumulation?.totalAmt ? accumulation?.totalAmt : 0)}</strong>
                              )}
                              <span
                                onClick={() => {
                                  if (isAppView) {
                                    RNPostMessage(AFWebLinkType.moveToLink, {
                                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/accumulation`,
                                    })
                                  } else {
                                    navigate(`/accumulation`)
                                  }
                                }}
                              >
                                적립금 내역
                              </span>
                            </div>
                          </div>
                        </div>

                        {pointModal ? (
                          isMobile ? (
                            <PointExchange
                              coin={coin}
                              setChangePointCheck={setCheckChangePoint}
                              memberNo={userData?.memberNo}
                              setIsModal={setPointModal}
                            ></PointExchange>
                          ) : (
                            <PointExchangeCenterModal
                              coin={coin}
                              setChangePointCheck={setCheckChangePoint}
                              memberNo={userData?.memberNo}
                              setIsModal={setPointModal}
                            ></PointExchangeCenterModal>
                          )
                        ) : null}
                      </div>
                    </div>

                    <div className='common_head' style={{ paddingTop: '0px' }}>
                      <div className='info_link'>
                        {/* {!isMobile ? (
                        <>
                          <Link to='/' className='purchase_amount'>
                            <div className='inner_flex'>
                              <img
                                src={`${imgURL}/icon_trophy.png`}
                                alt='트로피 이미지'
                              />
                              <p>
                                구매 금액 <br />
                                <span className='blue'>
                                  {plusComma(137900)}
                                </span>
                                원
                              </p>
                            </div>
                            <span>혜택 보기</span>
                          </Link>
                        </>
                      ) : null} */}
                        <Link
                          to='/mycoupon'
                          onClick={(event) => {
                            event.preventDefault()
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/mycoupon`,
                              })
                            } else {
                              navigate(`/mycoupon`)
                            }
                          }}
                        >
                          <div className='inner_flex'>
                            <img src={`${imgURL}/icon_money_check_dollar.png`} alt='쿠폰 이미지' />
                            <p className='coupon'>
                              {`사용 가능 쿠폰 `}
                              <em>{myItemCount}</em>장
                            </p>
                          </div>
                          <span>더 보기</span>
                        </Link>

                        <Link
                          to='/exhibitionlist'
                          onClick={(event) => {
                            event.preventDefault()
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitionlist`,
                              })
                            } else {
                              navigate(`/exhibitionlist`)
                            }
                          }}
                        >
                          <div className='inner_flex'>
                            <img src={`${imgURL}/icon_badge_percent.png`} alt='퍼센트 이미지' />
                            <p className='event'>
                              기획전/이벤트 <em>{plusComma(totalCount)}</em>개
                            </p>
                          </div>
                          <span>더 보기</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // 비회원일 경우
                <>
                  <div className='myshopping_header logout'>
                    <div className='common_head'>
                      <div className='login_wrap'>
                        <div className='welcome_wrap'>
                          <div className='inner_flex'>
                            <div className='profile_img'>
                              <img src={`${imgURL}/noprofile_img.png`} alt='프로필 이미지' />
                            </div>
                          </div>
                          <div className='user_info'>
                            <div className='user_tit'>
                              <div className='guest_greeting'>반가워요!</div>
                            </div>
                            <div className='purchase_benefit'>
                              <p>다양한 회원혜택을 만나보세요.</p>
                            </div>
                          </div>
                        </div>
                        <a
                          className='user_edit b_color btn_join_login'
                          onClick={() => {
                            setIsLogin(true)
                            // if (isAppView) {
                            //   RNPostMessage(AFWebLinkType.onSignInInducement)
                            // } else {
                            //   setIsLogin(true)
                            // }
                          }}
                        >
                          회원가입/로그인
                        </a>
                      </div>
                      {!isMobile && (
                        <Link to='/exhibitionlist' className='event_wrap'>
                          <div className='ongoing_event'>
                            <div className='inner_flex'>
                              <img src={`${imgURL}/icon_badge_percent.png`} alt='퍼센트 이미지' />
                              <p>
                                기획전/이벤트 <em>{plusComma(totalCount)}</em>개
                              </p>
                            </div>
                            <span>
                              {/* 내부 Link를 span으로 변경 */}
                              더 보기
                              <img src={`${imgURL}/icon_arrow_right_gray7.png`} alt='더 보기' />
                            </span>
                          </div>
                        </Link>
                      )}
                    </div>
                    {isMobile && (
                      <>
                        <div className='ongoing_event'>
                          <div className='inner_flex'>
                            <img src={`${imgURL}/icon_badge_percent.png`} alt='퍼센트 이미지' />
                            <p>
                              기획전/이벤트 <em>{plusComma(totalCount)}</em>개
                            </p>
                          </div>
                          <span>
                            <Link
                              to='/exhibitionlist'
                              onClick={(event) => {
                                event.preventDefault()
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitionlist`,
                                  })
                                } else {
                                  navigate(`/exhibitionlist`)
                                }
                              }}
                            >
                              더 보기
                              <IconArrowRight width={16} height={16} color='var(--colGray7)' />
                            </Link>
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
              {/* {!isMobile ? (
                <LogInCenterModal
                  setLoggedIn={setLoggedIn}
                ></LogInCenterModal>
              ) : null} */}
              {/* <div>
              <ChannelTalk></ChannelTalk>
            </div> */}
              <div className='banner mo'>
                <Swiper style={{ marginBottom: '0px' }} spaceBetween={8} slidesPerView={1.1312}>
                  {bannerItem.map((el: any) => {
                    return (
                      <SwiperSlide key={el.id}>
                        <Link
                          to={el.clickUrl}
                          onClick={(event) => {
                            event.preventDefault()
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${el.clickUrl}`,
                              })
                            } else {
                              navigate(el.clickUrl)
                            }
                          }}
                        >
                          <img src={el.mobileMainImage} alt='' />
                        </Link>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </div>
              <div className='banner pc'>
                {bannerItem.map((el: any) => {
                  return (
                    <div key={el.id}>
                      <Link to={el.clickUrl}>
                        <img src={el.pcMainImage} alt='' />
                      </Link>
                    </div>
                  )
                })}
                {/* <Swiper spaceBetween={16} slidesPerView={2.555}>
                {bannerItem.map((el: any) => {
                  return (
                    <SwiperSlide key={el.id}>
                      <Link to={el.clickUrl}>
                        <img src={el.pcMainImage} alt='' />
                      </Link>
                    </SwiperSlide>
                  );
                })}
              </Swiper> */}
              </div>

              <div className='sidemenu_mo'>
                <PageTitle style={{ padding: '20px 20px 12px' }}>계정정보</PageTitle>
                <ul
                  className='menu_list bot_line'
                  style={{
                    padding: hasAccessToken ? '0 20px 16px' : '0 20px 8px',
                  }}
                >
                  <li>
                    <Link
                      to='/recentView'
                      onClick={(event) => {
                        event.preventDefault()
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/recentView`,
                          })
                        } else {
                          navigate(`/recentView`)
                        }
                      }}
                    >
                      최근 본 상품<em>{recentCount}</em>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={hasAccessToken ? '/orderlistinquiry' : '/guestorderlist'}
                      onClick={(event) => {
                        event.preventDefault()
                        if (hasAccessToken) {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderlistinquiry`,
                            })
                          } else {
                            navigate(`/orderlistinquiry`)
                          }
                        } else {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/guestorderlist`,
                            })
                          } else {
                            navigate(`/guestorderlist`)
                          }
                        }
                      }}
                    >
                      주문 내역
                      {orderCount !== 0 ? <em>{orderCount}</em> : <em>0</em>}
                    </Link>
                  </li>
                  {hasAccessToken ? (
                    <>
                      <li>
                        <Link
                          to='/wishList'
                          onClick={(event) => {
                            event.preventDefault()
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                              })
                            } else {
                              navigate(`/wishList`)
                            }
                          }}
                        >
                          찜한 목록<em>{wishCount}</em>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to='/coupon'
                          onClick={(event) => {
                            event.preventDefault()
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/coupon`,
                              })
                            } else {
                              navigate(`/coupon`)
                            }
                          }}
                        >
                          쿠폰 받기
                        </Link>
                      </li>
                      <li>
                        <Link
                          to='/reviewlist/prepare'
                          onClick={(event) => {
                            event.preventDefault()
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/reviewlist/prepare`,
                              })
                            } else {
                              navigate(`/reviewlist/prepare`)
                            }
                          }}
                        >
                          상품 리뷰 <em>{reviewCount}</em>
                        </Link>
                      </li>
                      <li>{!isAppView && <Link to='/pushSetting'>푸시알림 설정</Link>}</li>
                    </>
                  ) : null}
                </ul>

                <PageTitle style={{ padding: '20px 20px 12px' }}>고객센터</PageTitle>
                <ul
                  className='menu_list bot_line'
                  style={{
                    padding: hasAccessToken ? '0 20px 16px' : '0 20px 48px',
                  }}
                >
                  {hasAccessToken && (
                    <li>
                      <Link
                        to='/productQnaList'
                        onClick={(event) => {
                          event.preventDefault()
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/productQnaList`,
                            })
                          } else {
                            navigate(`/productQnaList`)
                          }
                        }}
                      >
                        상품 Q&amp;A
                      </Link>
                    </li>
                  )}

                  {hasAccessToken && (
                    <li>
                      <Link
                        to='/inquiryList'
                        onClick={(event) => {
                          event.preventDefault()
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/inquiryList`,
                            })
                          } else {
                            navigate(`/inquiryList`)
                          }
                        }}
                      >
                        1:1 문의
                      </Link>
                    </li>
                  )}

                  <li>
                    <Link
                      to='/noticeList'
                      onClick={(event) => {
                        event.preventDefault()
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/noticeList`,
                          })
                        } else {
                          navigate(`/noticeList`)
                        }
                      }}
                    >
                      공지사항
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/faqList'
                      onClick={(event) => {
                        event.preventDefault()
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/faqList`,
                          })
                        } else {
                          navigate(`/faqList`)
                        }
                      }}
                    >
                      자주 묻는 질문
                    </Link>
                  </li>
                  {/* <li>
                  <Link to='/benefit'>혜택 소개</Link>
                </li> */}
                </ul>
                {hasAccessToken ? (
                  isAppView ? null : (
                    <div className='logout_box'>
                      <a
                        onClick={(e) => {
                          e.preventDefault()
                          const confirmed = window.confirm('로그아웃을 하시겠습니까?')
                          if (confirmed) {
                            ;<Link to='/recordGuide'></Link>
                            postLogout(Number(userData?.memberId))
                              .then(() => {
                                window.localStorage.removeItem('aboutRefreshToken')
                                window.localStorage.removeItem('aboutAccessToken')
                                window.localStorage.removeItem('accessToken')
                                window.localStorage.removeItem('lastAccessTokenUpdateTime')
                                delPrevScroll()
                                navigate('/')
                                window.location.reload()
                              })
                              .catch((err) => {
                                console.log(err)
                              })
                            window.crema.init(null, null)
                          }
                        }}
                      >
                        로그아웃
                      </a>
                    </div>
                  )
                ) : null}
                {/* {isModal && (
                  <LogInModal setLoggedIn={setLoggedIn}></LogInModal>
                )} */}
              </div>
            </div>
          </div>
          {/* <button
            className="channeltalkbtn"
            onClick={() => {
              const CT = new MyChannerlTalk();
              CT.boot({
                pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572',
                memberId: userData ? userData.memberId : '',
                profile: { mobileNumber: userData ? userData.mobileNo : '' },
              });
              CT.openChat();
              CT.hideChannelButton();
              return () => {
                CT.shutdown();
              };
            }}
          >
            <img src="/images/icon_channeltalk.png" alt="" />
          </button> */}
          {location.pathname === '/myshopping' && <ChannelTalkButton></ChannelTalkButton>}
        </div>
      </div>
    </>
  )
}

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LoadingSpinner = styled.div`
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  display: flex;
  margin: auto;
  width: 22px;
  height: 22px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #898989;
  animation: spinner 1s ease infinite;

  @media screen and (min-width: 768px) {
    width: 32px;
    height: 32px;
  }
`
